import kyra from './kyra.jpg';

import firebase from './firebase.png';
import js from './js.png';
import ts from './ts.png';
import node from './node.png';
import react from './reactjs.jpg';
import express from './express.png';

import ands from './ands.png';
import kotlin from './kotlin.jpg';

import unity from './unity.png';
import csharp from './csharp.png';
import blender from './blender.jpg';
import sub from './sub.png';

import splat from './Splat.png';

import converter from './converter.png';


const WebCollage = () => {
    const images = [
        firebase,
        js,
        ts,
        node,
        react,
        express
    ];

    return (
        <div className="collage-grid">
            {images.map((src, index) => (
                <div key={index} className={`collage-item item-1`}>
                    <img src={src} alt={`collage-${index}`} />
                </div>
            ))}
        </div>
    );
};

const AndroidCollage = () => {
    const images = [
        ands,
        kotlin,
        firebase
    ];

    return (
        <div className="collage-grid">
            {images.map((src, index) => (
                <div key={index} className={`collage-item item-1`}>
                    <img src={src} alt={`collage-${index}`} />
                </div>
            ))}
        </div>
    );
};

const UnityCollage = () => {
    const images = [
        unity,
        csharp,
        blender,
        sub
    ];

    return (
        <div className="collage-grid">
            {images.map((src, index) => (
                <div key={index} className={`collage-item item-1`}>
                    <img src={src} alt={`collage-${index}`} />
                </div>
            ))}
        </div>
    );
};

export { kyra, WebCollage, AndroidCollage, UnityCollage, splat, converter };